import {
  ISolCustomerOrderServiceContainer,
  IDeliveryService,
  IPickUpService,
  IRequestedAmount,
  ISolCustomerCommodity,
  ISolCustomerCommodityType,
  ISolCustomerDenominationPack,
  ISolCustomerDenominationQuantity,
  ISolCustomerPack,
  ISolCustomerPackQuantity,
  ISolCustomerSupply,
  ISolCustomerSupplyMaterialService,
} from "@/entities";

export class PickUpService implements IPickUpService {
  comments?: string;
  container?: ISolCustomerOrderServiceContainer[];
  countryCode?: string;
  description?: string;
  hasDate?: boolean;
  hasLimitDate?: boolean;
  isChange?: boolean;
  motiveId?: string;
  origin?: string;
  requestFinalTime?: string;
  requestInitialTime?: string;
  requestedAmounts?: IRequestedAmount[];
  responsable?: string;
  serviceAmount?: string;
  serviceDate?: string;
  serviceId?: string;
  serviceLimitDate?: string;
  servicePointId?: string;
  userName?: string;
  address?: string;
  applicant?: string;
  centerDescription?: string;
  custodianName?: string;
  documents?: any[];
  entityDescription?: string;
  plannedFinalTime?: string;
  plannedInitialTime?: string;
  realFinalTime?: string;
  realInitialTime?: string;
  routeCode?: string;
  serviceCode?: string;
  servicePointDescription?: string;

  constructor(data: IPickUpService) {
    this.comments = data.comments;
    this.countryCode = data.countryCode;
    this.description = data.description;
    this.hasDate = data.hasDate;
    this.hasLimitDate = data.hasLimitDate;
    this.isChange = data.isChange;
    this.motiveId = data.motiveId;
    this.origin = data.origin;
    this.requestFinalTime = data.requestFinalTime;
    this.requestInitialTime = data.requestInitialTime;
    this.responsable = data.responsable;
    this.serviceAmount = data.serviceAmount;
    this.serviceDate = data.serviceDate;
    this.serviceId = data.serviceId;
    this.serviceLimitDate = data.serviceLimitDate;
    this.servicePointId = data.servicePointId;
    this.userName = data.userName;
    this.address = data.address;
    this.applicant = data.applicant;
    this.centerDescription = data.centerDescription;
    this.custodianName = data.custodianName;
    this.documents = data.documents;
    this.entityDescription = data.entityDescription;
    this.plannedFinalTime = data.plannedFinalTime;
    this.plannedInitialTime = data.plannedInitialTime;
    this.realFinalTime = data.realFinalTime;
    this.realInitialTime = data.realInitialTime;
    this.routeCode = data.routeCode;
    this.serviceCode = data.serviceCode;
    this.servicePointDescription = data.servicePointDescription;

    this.container = data.container;
    this.requestedAmounts = data.requestedAmounts?.map(
      (requestedAmount) => new RequestedAmount(requestedAmount)
    );
  }
}

export class DeliveryService implements IDeliveryService {
  comments?: string;
  countryCode?: string;
  description?: string;
  hasDate?: boolean;
  hasLimitDate?: boolean;
  isChange?: boolean;
  motiveId?: string;
  origin?: string;
  requestFinalTime?: string;
  requestInitialTime?: string;
  requestedAmounts?: IRequestedAmount[];
  responsable?: string;
  serviceDate?: string;
  serviceId?: string;
  serviceLimitDate?: string;
  servicePointId?: string;
  userName?: string;
  address?: string;
  applicant?: string;
  centerDescription?: string;
  custodianName?: string;
  documents?: any[];
  entityDescription?: string;
  plannedFinalTime?: string;
  plannedInitialTime?: string;
  realFinalTime?: string;
  realInitialTime?: string;
  routeCode?: string;
  serviceCode?: string;
  servicePointDescription?: string;

  constructor(data: IDeliveryService) {
    this.comments = data.comments;
    this.countryCode = data.countryCode;
    this.description = data.description;
    this.hasDate = data.hasDate;
    this.hasLimitDate = data.hasLimitDate;
    this.isChange = data.isChange;
    this.motiveId = data.motiveId;
    this.origin = data.origin;
    this.requestFinalTime = data.requestFinalTime;
    this.requestInitialTime = data.requestInitialTime;
    this.responsable = data.responsable;
    this.serviceDate = data.serviceDate;
    this.serviceId = data.serviceId;
    this.serviceLimitDate = data.serviceLimitDate;
    this.servicePointId = data.servicePointId;
    this.userName = data.userName;
    this.address = data.address;
    this.applicant = data.applicant;
    this.centerDescription = data.centerDescription;
    this.custodianName = data.custodianName;
    this.documents = data.documents;
    this.entityDescription = data.entityDescription;
    this.plannedFinalTime = data.plannedFinalTime;
    this.plannedInitialTime = data.plannedInitialTime;
    this.realFinalTime = data.realFinalTime;
    this.realInitialTime = data.realInitialTime;
    this.routeCode = data.routeCode;
    this.serviceCode = data.serviceCode;
    this.servicePointDescription = data.servicePointDescription;

    this.requestedAmounts = data.requestedAmounts?.map(
      (requestedAmount) => new RequestedAmount(requestedAmount)
    );
  }
}

export class RequestedAmount implements IRequestedAmount {
  currencyDescription?: string;
  currencyIsoCode?: string;
  currencySymbol?: string;
  currencyId?: string;
  totalAmount?: number;
  denominations?: ISolCustomerDenominationQuantity[];
  packs?: ISolCustomerPackQuantity[];

  constructor(data: IRequestedAmount) {
    this.currencyDescription = data.currencyDescription;
    this.currencyIsoCode = data.currencyIsoCode;
    this.currencySymbol = data.currencySymbol;
    this.currencyId = data.currencyId;
    this.totalAmount = data.totalAmount;
    this.denominations = data.denominations?.map(
      (denomination) => new SolCustomerDenominationQuantity(denomination)
    );
    this.packs = data.packs?.map((pack) => new SolCustomerPackQuantity(pack));
  }
}

export class SolCustomerDenominationQuantity implements ISolCustomerDenominationQuantity {
  denominationId: string;
  denominationQuantity?: number | null;

  constructor(data: ISolCustomerDenominationQuantity) {
    this.denominationId = data.denominationId;
    this.denominationQuantity = data?.denominationQuantity;
  }
}

export class SolCustomerPackQuantity implements ISolCustomerPackQuantity {
  packId: string;
  packQuantity?: number | null;

  constructor(data: ISolCustomerPackQuantity) {
    this.packId = data.packId;
    this.packQuantity = data?.packQuantity;
  }
}

export class SolCustomerDenominationPack implements ISolCustomerDenominationPack {
  code?: string;
  currencyIsoCode?: string;
  currencySymbol?: string;
  description?: string;
  id?: string;
  quantity?: number;
  value?: number;

  constructor(data: ISolCustomerDenominationPack) {
    this.code = data.code;
    this.currencyIsoCode = data.currencyIsoCode;
    this.currencySymbol = data.currencySymbol;
    this.description = data.description;
    this.id = data.id;
    this.quantity = data.quantity;
    this.value = data.value;
  }
}

export class SolCustomerPack implements ISolCustomerPack {
  code?: string;
  denominations?: ISolCustomerDenominationPack[];
  description?: string;
  id?: string;

  constructor(data: ISolCustomerPack) {
    this.code = data.code;
    this.description = data.description;
    this.id = data.id;
    this.denominations = data.denominations?.map(
      (denominationPack) => new SolCustomerDenominationPack(denominationPack)
    );
  }
}

export class SolCustomerComodity implements ISolCustomerCommodity {
  code?: string;
  description?: string;
  id?: string;

  constructor(data: ISolCustomerCommodity) {
    this.code = data.code;
    this.description = data.description;
    this.id = data.id;
  }
}

export class SolCustomerComodityType implements ISolCustomerCommodityType {
  code?: string;
  commodities?: ISolCustomerCommodity[];
  description?: string;
  id?: string;

  constructor(data: ISolCustomerCommodityType) {
    this.code = data.code;
    this.description = data.description;
    this.id = data.id;
    this.commodities = data.commodities?.map((commodity) => new SolCustomerComodity(commodity));
  }
}

export class SolCustomerSupply implements ISolCustomerSupply {
  commodityTypeId?: string;
  commodityTypeDescription?: string;
  commodityId?: string;
  commodityDescription?: string;
  quantity?: number;

  constructor(data: ISolCustomerSupply) {
    this.commodityTypeId = data.commodityTypeId;
    this.commodityTypeDescription = data.commodityTypeDescription;
    this.commodityId = data.commodityId;
    this.commodityDescription = data.commodityDescription;
    this.quantity = data.quantity;
  }
}

export class SolCustomerSupplyMaterialService implements ISolCustomerSupplyMaterialService {
  servicePointId?: string;
  userName?: string;
  countryCode?: string;
  origin?: string;
  hasDate?: boolean;
  hasLimitDate?: boolean;
  supplies?: ISolCustomerSupply[];
  comments?: string;
  description?: string;
  motiveId?: string;
  requestFinalTime?: string;
  requestInitialTime?: string;
  responsable?: string;
  serviceDate?: string;
  serviceId?: string;
  address?: string;
  applicant?: string;
  centerDescription?: string;
  container?: ISolCustomerOrderServiceContainer[];
  custodianName?: string;
  documents?: any[];
  entityDescription?: string;
  plannedFinalTime?: string;
  plannedInitialTime?: string;
  realFinalTime?: string;
  realInitialTime?: string;
  routeCode?: string;
  serviceCode?: string;
  serviceLimitDate?: string;
  servicePointDescription?: string;

  constructor(data: ISolCustomerSupplyMaterialService) {
    this.servicePointId = data.servicePointId;
    this.userName = data.userName;
    this.countryCode = data.countryCode;
    this.origin = data.origin;
    this.hasDate = data.hasDate;
    this.hasLimitDate = data.hasLimitDate;
    this.comments = data.comments;
    this.description = data.description;
    this.motiveId = data.motiveId;
    this.requestFinalTime = data.requestFinalTime;
    this.requestInitialTime = data.requestInitialTime;
    this.responsable = data.responsable;
    this.serviceDate = data.serviceDate;
    this.serviceId = data.serviceId;
    this.address = data.address;
    this.applicant = data.applicant;
    this.centerDescription = data.centerDescription;

    this.custodianName = data.custodianName;
    this.documents = data.documents;
    this.entityDescription = data.entityDescription;
    this.plannedFinalTime = data.plannedFinalTime;
    this.plannedInitialTime = data.plannedInitialTime;
    this.realFinalTime = data.realFinalTime;
    this.realInitialTime = data.realInitialTime;
    this.routeCode = data.routeCode;
    this.serviceCode = data.serviceCode;
    this.serviceLimitDate = data.serviceLimitDate;
    this.servicePointDescription = data.servicePointDescription;
    this.container = data.container;
    this.supplies = data.supplies?.map((supply) => new SolCustomerSupply(supply));
  }
}
